module.exports = __webpack_public_path__ + "static/img/title_IP.c2d133d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/title_IP.png
// module id = pogP
// module chunks = 0